window.addEventListener("DOMContentLoaded", function () {
    if('cartCountdowns' in localStorage){
        const cartCountdowns = JSON.parse(localStorage.getItem('cartCountdowns'));

        for(let i=0; i < cartCountdowns.length; i++){
            const variantId = cartCountdowns[i].split(':')[0];
            const timerEnd = cartCountdowns[i].split(':')[1];

            const selector = "[data-cart-item-key^=" + CSS.escape(variantId.trim())+ "]";
            const cartItem = document.querySelector(selector);
            if(!cartItem) return;

            const timerEl = cartItem.querySelector('.reservation-countdown').querySelector('span');
            
            const intervalId = setInterval(updateTimer, 10 * 1000, timerEnd, timerEl);
            const diff = timerEnd - new Date().getTime();
            if(diff < 0){
                removeFromCart(variantId, intervalId);
                return;
            }
            updateTimer(timerEnd, timerEl);
            setTimeout(removeFromCart, diff, variantId, intervalId);
        }
    }
    else{
        const cartCountdowns = [];
        localStorage.setItem('cartCountdowns', JSON.stringify(cartCountdowns));
    }
});

function updateTimer(timerEnd, timerEl){
    const diff = timerEnd - new Date().getTime();
    // console.log("diff: " + diff);
    timerEl.innerHTML = Math.round(diff / 1000 / 60);
  }

function removeFromCart(variantId, intervalId){
    // console.log("removing from cart");
    // console.log(variantId);

    const config = fetchConfigDefaults();

    const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';
    const quantity = 0;
    const id = variantId;
    config.body = JSON.stringify({
      id,
      quantity,
      sections,
      sections_url: window.location.pathname,
    });

    const cartItem = document.querySelector("[data-cart-item-key^=" + CSS.escape(id)+ "]");

    fetch(theme.routes.cart_change_url, config)
          .then((res) => res.json())
          .then((data) => {
              clearInterval(intervalId);

              const cartCountdowns = JSON.parse(localStorage.getItem('cartCountdowns'));
              let elToRemove;
              for(let i=0; i < cartCountdowns.length; i++){
                if(cartCountdowns[i].includes(variantId)) elToRemove = i;
              }

              cartCountdowns.splice(elToRemove, 1);
              localStorage.setItem('cartCountdowns', JSON.stringify(cartCountdowns));

              document.body.dispatchEvent(
                new CustomEvent('cascade:modalcart:cartqtychange', {
                  bubbles: true,
                  detail: { response: data, originalTarget: cartItem },
                })
              );
          })
          .catch(() => {
            console.log("error");
          });
  }